import React from "react";
import { useNavigate } from "react-router-dom";

import SettingsScreenShell from "@/sot/layouts/SettingsScreenShell.jsx";
import TopBarCenter from "@/sot/primitives/TopBarCenter.jsx";

export default function PreferencesPageShell({
  role = "patient",
  title = "",
  subtitle = "",
  children,
}) {
  const nav = useNavigate();

  return (
    <SettingsScreenShell>
      <TopBarCenter
        close
        onBack={() => nav(`/settings/${role}/preferences`)}
        title={title}
      />

      {subtitle ? (
        <p className="mt-2 text-body-medium text-on-surface-var">{subtitle}</p>
      ) : null}

      <div className="mt-5 space-y-4">{children}</div>
    </SettingsScreenShell>
  );
}
